var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isShow)?_c('div',[_c('div',{staticClass:"loader"},[_vm._v("Loading...")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }